import { oTUser } from "../../constants/routes";
import { editModel } from "../../utils/backend";
import * as actionTypes from "../actionTypes";

const initialState = {
    CurrentEntity: "",
    OpenDrawer: true,
    TreeMenuWidth: 320,
    SettingsMenuWidth: 0,
    LastEntityTreeUpdate: new Date().toUTCString(),
    LastBranchCountryTreeUpdate: new Date().toUTCString(),
    LastRecycleBinGridRefresh: new Date().toUTCString(),
    ShowAdvancedSearchCriterias: false,
    QuickSearchFilter: {
        SearchCategories: undefined,
        SearchCriterias: undefined
    },
    SearchCategoriesImmediate: undefined,
    MaxResultCount: undefined,
    LastFilterCriteriasUpdate: new Date().toUTCString(),
    QuickSearch: "",
    TreeViewNodeExpand: [],
    DifferentEntitySelected: false,
    HighlightedRows: {},
    Bookmarks: [],
    MapsPrefs: {},
    IsFetching: false,
    ClientHistory: {},
    NextClientRoute: "",
    NotificationCount: 0,
    SheetName: "eddDataValidation.Stations",
    EddDataValidationProgress: 0,
    GlobalSearchBarRefresh: 0,
    EntitiesResults: undefined,
    DocumentsResults: undefined,
    StationsResults: undefined,
    ZonesResults: undefined,
    SamplingsResults: undefined,
    NavigationPath: [],
    EntityStatuses: null,
};

/** Reducer handling update of states related to user's session preferences.  DOC*/
export default function UserPrefReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.CURRENTENTITY:
            return {
                ...state,
                CurrentEntity: action.payload.CurrentEntity,
            };
        case actionTypes.TREEMENUWIDTH:
            return {
                ...state,
                TreeMenuWidth: action.payload.TreeMenuWidth,
            };
        case actionTypes.SETTINGSMENUWIDTH:
            return {
                ...state,
                SettingsMenuWidth: action.payload.SettingsMenuWidth,
            };
        case actionTypes.UPDATEENTITYTREE:
            return {
                ...state,
                LastEntityTreeUpdate: new Date().toUTCString(),
            };
        case actionTypes.UPDATESPECIFICNODE:
            return {
                ...state,
                nodeToRefreshID: action.payload.nodeToRefreshID,
            };
        case actionTypes.QUICKSEARCHFILTER:
            return {
                ...state,
                QuickSearchFilter: action.payload.QuickSearchFilter,
            };
        case actionTypes.SEARCHCATEGORIES_IMMEDIATE:
            return {
                ...state,
                SearchCategoriesImmediate: action.payload.SearchCategoriesImmediate,
            };
        case actionTypes.MAXRESULTCOUNT:
            return {
                ...state,
                MaxResultCount: action.payload.MaxResultCount,
            };
        case actionTypes.QUICKSEARCH:
            return {
                ...state,
                QuickSearch: action.payload,
            };
        case actionTypes.TREEVIEWNODEEXPAND:
            return {
                ...state,
                TreeViewNodeExpand: action.payload.TreeViewNodeExpand,
            };
        case actionTypes.DIFFERENTENTITYSELECTED:
            return {
                ...state,
                DifferentEntitySelected: action.payload.DifferentEntitySelected,
            };
        case actionTypes.UPDATEHIGHLIGHTEDROWS:
            return {
                ...state,
                HighlightedRows: {
                    ...state.HighlightedRows,
                    [Object.keys(action.payload)[0]]: Object.values(
                        action.payload
                    )[0],
                },
            };
        case actionTypes.MENUBOOKMARKED:
            const oldBookmarked = state.Bookmarks
                ? state.Bookmarks.filter(t => t !== action.payload.TreeNode)
                : [];

            const Bookmarks = [...oldBookmarked, action.payload.TreeNode];
            editModel(
                Bookmarks,
                "",
                action.payload.token,
                `${oTUser}/bookmarkPrefs`
            );
            return {
                ...state,
                Bookmarks,
            };
        case actionTypes.MENUUNBOOKMARKED:
            const oldBookmarked2 = state.Bookmarks
                ? state.Bookmarks.filter(
                      t => t.Route !== action.payload.TreeNode.Route
                  )
                : [];

            editModel(
                oldBookmarked2,
                "",
                action.payload.token,
                `${oTUser}/bookmarkPrefs`
            );

            return {
                ...state,
                Bookmarks: oldBookmarked2,
            };
        case actionTypes.MAPPREF:
            const newMapsPrefs = { ...state.MapsPrefs };
            newMapsPrefs[action.payload.map] = action.payload.mapState;
            editModel(
                newMapsPrefs,
                "",
                action.payload.token,
                `${oTUser}/mapPrefs`
            );
            return {
                ...state,
                MapsPrefs: newMapsPrefs,
            };
        case actionTypes.INITIALIZEPREFS:
            return {
                ...state,
                MapsPrefs: action.payload.MapPrefs,
                Bookmarks: action.payload.BookmarkPrefs,
            };
        case actionTypes.ISFETCHING:
            return {
                ...state,
                IsFetching: action.payload,
            };
        case actionTypes.NEXTFOLLOWEDUSERROUTE:
            return {
                ...state,
                ClientHistory: action.payload.ClientHistory,
                NextClientRoute: action.payload.NextClientRoute,
            };
        case actionTypes.NEWNOTIFCOUNT:
            return {
                ...state,
                NotificationCount: action.payload.Value,
            };
        case actionTypes.CONSOLELOG:
            return state;
        case actionTypes.UPDATESHEETNAME:
            return {
                ...state,
                SheetName: action.payload.SheetName,
            };
        case actionTypes.UPDATEDATAVALIDATIONPROGRESS:
            return {
                ...state,
                EddDataValidationProgress: action.payload.Progress,
            };
        case actionTypes.REFRESH_GLOBALSEARCHBAR:
            return {
                ...state,
                GlobalSearchBarRefresh: action.payload.timestamp,
            };
        case actionTypes.UPDATEBRANCHESANDCOUNTRIES:
            return {
                ...state,
                LastBranchCountryTreeUpdate: new Date().toUTCString(),
            };
        case actionTypes.REFRESHRECYCLEBINGRID:
            return {
                ...state,
                LastRecycleBinGridRefresh: action.payload.timestamp,
            };
        case actionTypes.SHOW_ADVANCED_SEARCH_CRITERIAS:
            return {
                ...state,
                ShowAdvancedSearchCriterias: action.payload.ShowAdvancedSearchCriterias,
            };
        case actionTypes.UPDATE_ENTITIES_RESULTS:
            return {
                ...state,
                EntitiesResults: action.payload.results,
            };
        case actionTypes.UPDATE_DOCUMENTS_RESULTS:
            return {
                ...state,
                DocumentsResults: action.payload.results,
            };
        case actionTypes.UPDATE_STATIONS_RESULTS:
            return {
                ...state,
                StationsResults: action.payload.results,
            };
        case actionTypes.UPDATE_ZONES_RESULTS:
            return {
                ...state,
                ZonesResults: action.payload.results,
            };
        case actionTypes.UPDATE_SAMPLINGS_RESULTS:
            return {
                ...state,
                SamplingsResults: action.payload.results,
            };
        case actionTypes.CLEAR_SEARCH_RESULTS:
            return {
                ...state,
                EntitiesResults: undefined,
                DocumentsResults: undefined,
                StationsResults: undefined,
                ZonesResults: undefined,
                SamplingsResults: undefined,
            };
        case actionTypes.FILTER_CRITERIAS_UPDATED:
            return {
                ...state,
                LastFilterCriteriasUpdate: action.payload.timestamp
            };
        case actionTypes.UPDATENAVIGATIONPATH:
            return {
                ...state,
                NavigationPath: action.payload.NavigationPath,
            };
        case actionTypes.REFRESHNAVIGATIONPATH:
            return {
                ...state,
                LastNavigationPathUpdate: action.payload.timestamp,
            };
        case actionTypes.UPDATE_ENTITY_STATUSES:
            return {
                ...state,
                EntityStatuses: action.payload.EntityStatuses,
            };
        default:
            return state;
    }
}
